const TAG_MAC_ADDRESS_PREFIX_REGEX = new RegExp(
  [
    /(18([:\-. ])?FD([:\-. ])?74)/,
    /(48([:\-. ])?A9([:\-. ])?8A)/,
    /(DC([:\-. ])?2C([:\-. ])?6E)/,
    /(2C([:\-. ])?C8([:\-. ])?1B)/,
    /(CC([:\-. ])?2D([:\-. ])?E0)/,
    /(74([:\-. ])?4D([:\-. ])?28)/,
    /(D4([:\-. ])?CA([:\-. ])?6D)/,
    /(4C([:\-. ])?5E([:\-. ])?0C)/,
    /(E4([:\-. ])?8D([:\-. ])?8C)/,
    /(64([:\-. ])?D1([:\-. ])?54)/,
    /(48([:\-. ])?8F([:\-. ])?5A)/,
    /(C4([:\-. ])?AD([:\-. ])?34)/,
    /(6C([:\-. ])?3B([:\-. ])?6B)/,
    /(00([:\-. ])?0C([:\-. ])?42)/,
    /(B8([:\-. ])?69([:\-. ])?F4)/,
    /(08([:\-. ])?55([:\-. ])?31)/,
    /(04([:\-. ])?F4([:\-. ])?1C)/,
    /(78([:\-. ])?9A([:\-. ])?18)/,
    /(D4([:\-. ])?01([:\-. ])?C3)/,
    /(F4([:\-. ])?1E([:\-. ])?57)/
  ]
    .map(r => r.source)
    .join('|')
);

const TAG_MAC_ADDRESS_SUFFIX_REGEX = /(([:\-. ])?([0-9A-F]){2}){3}$/;
const TAG_MAC_ADDRESS_REGEX = new RegExp(
  '(' + TAG_MAC_ADDRESS_PREFIX_REGEX.source + ')' + TAG_MAC_ADDRESS_SUFFIX_REGEX.source
);

export const macAddressValid = (macAddress: string) => TAG_MAC_ADDRESS_REGEX.test(macAddress);
